import React, { useMemo } from "react";
import { Heading } from "../../../../../../../../components/headers/heading/heading.component";
import { createFlyerDetailPageSubHeaderText } from "../../types/flyer-detail-page-drawer-header/flyer-detail-page-drawer-sub-header.functions";
import { FlyerDetailPageDrawerSubHeaderProps } from "./flyer-detail-page-drawer-sub-header.props";

export const FlyerDetailPageDrawerSubHeader = (props: FlyerDetailPageDrawerSubHeaderProps) => {
  const heading = useMemo(
    () => createFlyerDetailPageSubHeaderText(props.pageLabel, props.editType),
    [props]
  );

  return <Heading variant="sub">{heading}</Heading>;
};
